import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateTimecodesMutation } from "../graphql/mutations";
import type {
  UpdateTimecodesMutationType,
  UpdateTimecodesMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateTimecodesMutation = (
  options?: MutationHookOptions<
    UpdateTimecodesMutationType,
    UpdateTimecodesMutationVariablesType
  >
) => {
  return useMutation<
    UpdateTimecodesMutationType,
    UpdateTimecodesMutationVariablesType
  >(UpdateTimecodesMutation, options);
};
